var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "placeOrder warp" },
    [
      _c(
        "div",
        { staticClass: "poAddressBox" },
        [
          _c("div", { staticClass: "poTitle" }, [_vm._v("请选择收货地址")]),
          _vm._v(" "),
          _c("div", { staticClass: "poAddressList" }, [
            _c(
              "div",
              { staticClass: "poAddListTit", on: { click: _vm.newAddressFn } },
              [
                _c("a-icon", { attrs: { type: "environment" } }),
                _vm._v(" "),
                _c("span", [_vm._v("新增收货地址")])
              ],
              1
            ),
            _vm._v(" "),
            _vm.addressData.length !== 0
              ? _c("div", { staticClass: "poAddListBox" }, [
                  _c("div", [_vm._v("收货地址")]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "div",
                      {
                        staticClass: "showMoreBox",
                        class: { showMoreAdd: _vm.showMoreAddress }
                      },
                      _vm._l(_vm.addressData, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: item.receiveId,
                            staticClass: "addressItem",
                            class: { addressActive: _vm.curAdd === index },
                            on: {
                              click: function($event) {
                                return _vm.selectAddress(item, index)
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "userName" }, [
                              _vm._v(_vm._s(item.receiveName))
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "addressInfo" }, [
                              _vm._v(
                                _vm._s(item.receiveAdress) +
                                  " " +
                                  _vm._s(item.address)
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "phone" }, [
                              _vm._v(_vm._s(item.receivePhone))
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "defaultAddress",
                                class: "" + (item.ifDefault ? "hasHeader" : "")
                              },
                              [_vm._v(_vm._s(item.ifDefault ? "默认地址" : ""))]
                            ),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "el-icon-edit",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.editAddress(item, index)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.showDelete(item)
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "iconfont" }, [
                                  _vm._v("")
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _vm.curAdd === index
                              ? _c("i", { staticClass: "iconfont" }, [
                                  _vm._v("")
                                ])
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm.addressData.length > 3
                      ? _c("div", {
                          staticClass: "openMore iconfont",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.showMoreAddress ? "&#xe660;" : "&#xe695;"
                            )
                          },
                          on: { click: _vm.openMoreAdd }
                        })
                      : _vm._e()
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "poTitle" }, [_vm._v("请确认订单信息")]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("shop-order", {
            ref: "shopOrder",
            attrs: { type: _vm.state, shopsData: _vm.shopsData }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "remarksBox" }, [
        _c(
          "div",
          { staticClass: "remarksInfo" },
          [
            _c("el-input", {
              attrs: {
                type: "textarea",
                rows: 2,
                resize: "none",
                maxlength: "200",
                placeholder: "如有其他要求，请备注。"
              },
              model: {
                value: _vm.remarksInfo,
                callback: function($$v) {
                  _vm.remarksInfo = $$v
                },
                expression: "remarksInfo"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "couponBox" }, [
        _vm.settlementData.coupons.length !== 0
          ? _c("div", { staticClass: "couponTitle" }, [
              _c("span", [
                _vm._v("\n        使用优惠券\n        "),
                _c("i", {
                  staticClass: "iconfont",
                  domProps: { innerHTML: _vm._s("&#xe695;") }
                })
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "discountList clearfix" },
          [
            _vm._l(_vm.settlementData.coupons, function(item, index) {
              return _c(
                "div",
                {
                  key: item.couponId,
                  staticClass: "couponItem",
                  class: { active: _vm.curPrefCouponInx === index },
                  on: {
                    click: function($event) {
                      return _vm.preferentialUse(item, index)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "couponItemTop" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../assets/images/indexLogo.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _c("i", [_vm._v("￥")]),
                      _vm._v(
                        "\n            " +
                          _vm._s(item.reduceMoney) +
                          "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticStyle: { height: "15px" } }, [
                      _vm._v("使用条件：" + _vm._s(item.content))
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("有效期至：" + _vm._s(item.endTime))]),
                    _vm._v(" "),
                    _c("div", { staticClass: "couponType" }, [_vm._v("平台卷")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "couponItemBot" }, [
                    _vm._v("\n          立即使用\n          "),
                    _vm.curPrefCouponInx === index
                      ? _c("span", { staticClass: "iconfont currentSelect" }, [
                          _vm._v("")
                        ])
                      : _vm._e()
                  ])
                ]
              )
            }),
            _vm._v(" "),
            _vm._l(_vm.shopsData, function(item, index) {
              return _c(
                "div",
                { key: item.shopId },
                _vm._l(item.shopCoupons, function(shop) {
                  return _c(
                    "div",
                    {
                      key: shop.id,
                      staticClass: "couponItem",
                      class: { active: _vm.shopCoupons[index].id === shop.id },
                      on: {
                        click: function($event) {
                          return _vm.selectShopCoupon(item, index, shop)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "couponItemTop" }, [
                        _c("img", {
                          attrs: {
                            src: require("../../assets/images/indexLogo.png"),
                            alt: ""
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("优惠：" + _vm._s(shop.content))]),
                        _vm._v(" "),
                        _c("span", { staticStyle: { height: "15px" } }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v("有效期至：" + _vm._s(shop.endTime))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "couponType" }, [
                          _vm._v("店铺券")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "couponItemBot" }, [
                        _vm._v("\n            立即使用\n            "),
                        _vm._v(" "),
                        _vm.shopCoupons[index].id === shop.id
                          ? _c(
                              "span",
                              { staticClass: "iconfont currentSelect" },
                              [_vm._v("")]
                            )
                          : _vm._e()
                      ])
                    ]
                  )
                }),
                0
              )
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "couponList" },
          [
            _c("div", { staticClass: "payTit" }, [_vm._v("选择支付方式")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "flex-start",
                  "align-item": "center",
                  "flex-wrap": "wrap"
                }
              },
              [
                _c("div", { staticClass: "payList" }, [
                  _vm.enablePaymentMode.indexOf(3) != -1
                    ? _c(
                        "div",
                        {
                          class: { payActive: _vm.payType === "3" },
                          on: {
                            click: function($event) {
                              _vm.selectPay((_vm.type = "3"))
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("../../assets/images/offline_pay.png"),
                              alt: ""
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(1),
                          _vm._v(" "),
                          _vm.payType === "3"
                            ? _c("span", { staticClass: "el-icon-check" })
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: { payActive: _vm.payType === "4" },
                      on: {
                        click: function($event) {
                          _vm.selectPay((_vm.type = "4"))
                        }
                      }
                    },
                    [
                      _vm.chackData.flag == 3
                        ? _c("img", {
                            attrs: {
                              src: require("../../assets/images/online_credit_pay.png"),
                              alt: ""
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.chackData.flag == 4 ||
                      _vm.chackData.flag == 5 ||
                      _vm.chackData.flag == 6 ||
                      _vm.chackData.flag == 1 ||
                      _vm.chackData.flag == 2
                        ? _c("img", {
                            attrs: {
                              src: require("../../assets/images/payment@2x.png"),
                              alt: ""
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", [
                        _c("p", [
                          _vm._v(
                            "\n                账期支付\n                "
                          ),
                          _vm.chackData.flag == 1
                            ? _c("span", { staticClass: "hint" }, [
                                _vm._v("(未开通)")
                              ])
                            : _vm.chackData.flag == 2
                            ? _c("span", { staticClass: "hint" }, [
                                _vm._v(
                                  "\n                  (等待商家审核)\n                "
                                )
                              ])
                            : _vm.chackData.flag == 3 && !_vm.balanceAmount
                            ? _c("span", { staticClass: "hint" }, [
                                _vm._v(
                                  "\n                  (已开通)\n                "
                                )
                              ])
                            : _vm.chackData.flag == 4
                            ? _c("span", { staticClass: "hint gray" }, [
                                _vm._v(
                                  "\n                  (已冻结)\n                "
                                )
                              ])
                            : _vm.chackData.flag == 5
                            ? _c("span", { staticClass: "hint gray" }, [
                                _vm._v(
                                  "\n                  (已终止)\n                "
                                )
                              ])
                            : _vm.chackData.flag == 6
                            ? _c("span", { staticClass: "hint gray" }, [
                                _vm._v(
                                  "\n                  (存在未开通账期的商品)\n                "
                                )
                              ])
                            : _vm.balanceAmount
                            ? _c("span", { staticClass: "hint gray" }, [
                                _vm._v(
                                  "\n                  (余额不足)\n                "
                                )
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm.chackData.flag == 4 ||
                        _vm.chackData.flag == 5 ||
                        _vm.chackData.flag == 2
                          ? _c(
                              "p",
                              {
                                staticClass: "p1",
                                staticStyle: { color: "#999999" }
                              },
                              [
                                _vm._v(
                                  "\n                联系商家协商：" +
                                    _vm._s(_vm.chargePersonPhone) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.chackData.flag == 3 || _vm.chackData.flag == 6
                          ? _c("p", [
                              _vm._v(
                                "\n                还有\n                "
                              ),
                              _c("span", [
                                _vm._v(_vm._s(_vm.chackData.balanceAmount))
                              ]),
                              _vm._v(
                                "\n                额度可以使用\n                "
                              ),
                              _vm.balanceAmount
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#ff4747",
                                        "margin-left": "10px"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  联系商家：" +
                                          _vm._s(_vm.chargePersonPhone) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.chackData.flag == 6
                          ? _c(
                              "p",
                              {
                                staticClass: "p1",
                                staticStyle: {
                                  color: "#999999",
                                  "margin-top": "10px"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                联系商家开通：" +
                                    _vm._s(_vm.chargePersonPhone) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.chackData.flag == 1
                          ? _c("p", { staticClass: "open" }, [
                              _c(
                                "span",
                                {
                                  on: {
                                    click: function($event) {
                                      _vm.paymentDays = true
                                    }
                                  }
                                },
                                [_vm._v("立即开通")]
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _vm.payType === "4"
                        ? _c("span", { staticClass: "el-icon-check" })
                        : _vm._e()
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm.enablePaymentMode.indexOf(6) != -1
                  ? _c("div", { staticClass: "payList" }, [
                      _c(
                        "div",
                        {
                          class: { payActive: _vm.payType === "6" },
                          on: {
                            click: function($event) {
                              _vm.selectPay((_vm.type = "6"))
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("../../assets/images/jufutong.png"),
                              alt: ""
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(2),
                          _vm._v(" "),
                          _vm.payType === "6"
                            ? _c("span", { staticClass: "el-icon-check" })
                            : _vm._e()
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.enablePaymentMode.indexOf(7) != -1
                  ? _c("div", { staticClass: "payList" }, [
                      _c(
                        "div",
                        {
                          class: { payActive: _vm.payType === "7" },
                          on: {
                            click: function($event) {
                              _vm.selectPay((_vm.type = "7"))
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("../../assets/images/jufutong.png"),
                              alt: ""
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(3),
                          _vm._v(" "),
                          _vm.payType === "7"
                            ? _c("span", { staticClass: "el-icon-check" })
                            : _vm._e()
                        ]
                      )
                    ])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "开通账期",
                  visible: _vm.paymentDays,
                  center: false,
                  width: "542px"
                },
                on: {
                  "update:visible": function($event) {
                    _vm.paymentDays = $event
                  }
                }
              },
              [
                _c("div", { staticClass: "confimPaymentDaysContent" }, [
                  _c("p", { staticClass: "p1" }, [
                    _vm._v(
                      "\n            您好，您正在申请开通当前店铺的“账期支付”功能，请您认真阅读以下信息：\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "p1" }, [
                    _vm._v(
                      "\n            账期支付是先消费后付款的支付服务，其法律关系仅存在于您与商家之间。商家将根据您当前帐号的信誉和交易合作进行评估，自行决定是否为您开通“账期支付”功能以及设置具体使用细则（包括但不限于账期额度、支付周期、授权商品、使用条件等）。\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "p1" }, [
                    _vm._v(
                      "\n            账期支付功能开通后，您可使用商家授信的账期额度采购商家授权的商品，您需在支付周期内结清应还款项。\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "p1" }, [
                    _vm._v(
                      "\n            关于“账期支付”具体使用细则您可联系当前店铺客服进行协商。线上客服入口正在开发中，您可通过店铺客服电话或微信联系商家。\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.chargePersonName) +
                        "店铺客服电话：\n            "
                    ),
                    _c("span", [_vm._v(_vm._s(_vm.chargePersonPhone))])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "confimPaymentDays1",
                        on: {
                          click: function($event) {
                            _vm.paymentDays = false
                          }
                        }
                      },
                      [_vm._v("\n            取消\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "confimPaymentDays2",
                        on: { click: _vm.applyForMoney }
                      },
                      [_vm._v("\n            点击确认提交申请\n          ")]
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "el-dialog",
              {
                attrs: {
                  visible: _vm.confirmApplyForMoney,
                  width: "26%",
                  "show-close": true
                },
                on: {
                  "update:visible": function($event) {
                    _vm.confirmApplyForMoney = $event
                  }
                }
              },
              [
                _c("div", { staticClass: "confirmApplyForMoney" }, [
                  _c("div", [
                    _c("img", {
                      attrs: {
                        src: require("../../assets/images/success@2x.png"),
                        alt: ""
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", [_vm._v("申请提交,等待商家授信!")])
                ])
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("a-spin", { attrs: { spinning: _vm.spinning } }, [
        _c(
          "div",
          { staticClass: "placeOrderBtn" },
          [
            _c("span", [_vm._v("运费：+¥" + _vm._s(_vm.distributionPrice))]),
            _vm._v(" "),
            _c("span", [
              _vm._v("商品优惠：-￥" + _vm._s(_vm.prefDis + _vm.shopCouponDis))
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v("\n        需付款：\n        "),
              _c("b", [_vm._v("￥" + _vm._s(_vm.orderDisTotal))])
            ]),
            _vm._v(" "),
            _c(
              "el-button",
              {
                directives: [{ name: "throttle", rawName: "v-throttle" }],
                attrs: { type: "primary" },
                on: { click: _vm.clickPayOrder }
              },
              [_vm._v("提交订单")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "请在1小时内完成付款，否则订单会被系统取消",
            visible: _vm.paymentDialog,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.paymentDialog = $event
            }
          }
        },
        [
          _c("div", { staticClass: "payment" }, [
            _c("div", { staticClass: "paymentBox" }, [
              _c(
                "div",
                { staticClass: "successBox" },
                [
                  _c("span", [_vm._v("支付成功请点击")]),
                  _vm._v(" "),
                  _c("el-button", { attrs: { type: "primary", plain: "" } }, [
                    _vm._v("已完成付款")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "errorBox" },
                [
                  _c("span", [_vm._v("遇到问题请点击")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [{ name: "throttle", rawName: "v-throttle" }],
                      attrs: { type: "primary" }
                    },
                    [_vm._v("重新付款")]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "paymentInfo" }, [
              _c("p", [_vm._v("注：重新付款前，请关闭之前的付款页面")]),
              _vm._v(" "),
              _c("p", [
                _vm._v("\n          如有疑问或需要帮助，请进入\n          "),
                _c("b", [_vm._v("帮助中心")]),
                _vm._v("或联系\n          "),
                _c("b", [_vm._v("在线客服")])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "weChat",
          attrs: {
            visible: _vm.weChatDialog,
            "before-close": _vm.handleClose,
            width: "25%"
          },
          on: {
            "update:visible": function($event) {
              _vm.weChatDialog = $event
            }
          }
        },
        [
          _c("div", { staticClass: "weChatBox" }, [
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "18px",
                  color: "#000000",
                  padding: "0 20px"
                }
              },
              [
                _vm._v(
                  "\n        请使用具有扫码支付功能的APP完成支付（支持微信、支付宝、云闪付等APP）\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "32px",
                  color: "#000000",
                  width: "100%",
                  "text-align": "center"
                }
              },
              [_vm._v("\n        ￥" + _vm._s(_vm.payInfo.money) + "\n      ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "qCode" }, [
              _c("img", {
                attrs: {
                  src: "data:image/jpeg;base64," + _vm.payInfo.c2bQrCodeBase64,
                  width: "100%",
                  height: "100%",
                  alt: ""
                }
              })
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: (_vm.curDialogAddress ? "编辑" : "新建") + "收货地址",
            visible: _vm.newAddressDialog,
            width: "630px"
          },
          on: {
            "update:visible": function($event) {
              _vm.newAddressDialog = $event
            }
          }
        },
        [
          _c("add-address", {
            on: { hideAddDialog: _vm.hideAddDialog, cancelAdd: _vm.closeAdd }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "是否删除此项",
            visible: _vm.showDeleteAdd,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.showDeleteAdd = $event
            }
          }
        },
        [
          _c("div", { staticClass: "deleteAddInfo" }, [
            _c("p", [
              _vm._v("收货人： " + _vm._s(_vm.delCurrentAdd.receiveName))
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("手机号码： " + _vm._s(_vm.delCurrentAdd.receivePhone))
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        收货地址： " +
                  _vm._s(_vm.delCurrentAdd.receiveAdress) +
                  "\n        " +
                  _vm._s(_vm.delCurrentAdd.address) +
                  "\n      "
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.showDeleteAdd = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [{ name: "throttle", rawName: "v-throttle" }],
                  attrs: { type: "primary" },
                  on: { click: _vm.deleteAdd }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "错误！", visible: _vm.errorDialog, width: "30%" },
          on: {
            "update:visible": function($event) {
              _vm.errorDialog = $event
            }
          }
        },
        [
          _c("div", { staticClass: "errorDialog" }, [
            _c("div", { staticClass: "errorTit" }, [
              _c("span", { staticClass: "iconfont" }, [_vm._v("")]),
              _vm._v(" "),
              _c("p", [_vm._v("您的订单支付失败")])
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer"
              },
              [
                _c(
                  "el-button",
                  {
                    directives: [{ name: "throttle", rawName: "v-throttle" }],
                    on: {
                      click: function($event) {
                        _vm.dialogVisible = false
                      }
                    }
                  },
                  [_vm._v("查看订单")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    directives: [{ name: "throttle", rawName: "v-throttle" }],
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        _vm.dialogVisible = false
                      }
                    }
                  },
                  [_vm._v("重新支付")]
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "orderList" }, [
      _c("div", { staticClass: "orderInfoTit" }, [
        _c("span", [_vm._v("商品名称")]),
        _vm._v(" "),
        _c("span", [_vm._v("商品属性")]),
        _vm._v(" "),
        _c("span", [_vm._v("单价")]),
        _vm._v(" "),
        _c("span", [_vm._v("数量")]),
        _vm._v(" "),
        _c("span", [_vm._v("优惠方式")]),
        _vm._v(" "),
        _c("span", [_vm._v("小计")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [_vm._v("转账汇款")]),
      _vm._v(" "),
      _c("p", [_vm._v("收款账户:保山数字产业发展有限责任公司")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [_vm._v("聚富通支付")]),
      _vm._v(" "),
      _c("p", [_vm._v("工商银行储蓄卡")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [_vm._v("e企付")]),
      _vm._v(" "),
      _c("p", [_vm._v("工商银行储蓄卡")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-264fde64", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-264fde64","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/placeOrder/index.vue
// module id = null
// module chunks = 